import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { fonts as fontsApi } from '../../api/client.js';

export default function BulkActionBar({
  selectedFontIds, collections, tags,
  onBulkAddToCollection, onBulkTag,
  onBulkActivate, onBulkDelete, onClearSelection,
}) {
  const { theme, isDark } = useTheme();
  const [showCollectionDropdown, setShowCollectionDropdown] = useState(false);
  const [showTagDropdown, setShowTagDropdown] = useState(false);

  return (
    <div style={{
      position: 'sticky', bottom: 0, left: 0, right: 0,
      padding: '10px 24px',
      background: isDark ? 'rgba(20,20,24,0.97)' : 'rgba(245,245,247,0.97)',
      borderTop: `1px solid ${theme.borderMedium}`,
      display: 'flex', alignItems: 'center', gap: 12,
      backdropFilter: 'blur(12px)', zIndex: 50,
    }}>
      <span style={{ fontSize: 12, fontWeight: 600, color: theme.textSecondary, marginRight: 4 }}>
        {selectedFontIds.size} font{selectedFontIds.size !== 1 ? 's' : ''} selected
      </span>

      <div style={{ position: 'relative' }}>
        <button
          onClick={() => { setShowCollectionDropdown(!showCollectionDropdown); setShowTagDropdown(false); }}
          style={{
            background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
            borderRadius: 0, color: theme.textSecondary,
            fontSize: 11, fontWeight: 500, padding: '6px 12px',
            cursor: 'pointer', fontFamily: 'inherit',
          }}
        >add to collection</button>
        {showCollectionDropdown && (
          <div style={{
            position: 'absolute', bottom: '100%', left: 0, marginBottom: 4,
            background: theme.bgElevated, border: `1px solid ${theme.borderHover}`,
            borderRadius: 0, padding: 4, minWidth: 160, zIndex: 60,
            boxShadow: theme.shadow,
          }}>
            {collections.filter(c => c.id > 0).map(c => (
              <button
                key={c.id}
                onClick={() => { onBulkAddToCollection(c.id); setShowCollectionDropdown(false); }}
                style={{
                  width: '100%', padding: '6px 10px', background: 'none',
                  border: 'none', borderRadius: 0, color: theme.textSecondary,
                  fontSize: 11, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                }}
                onMouseEnter={e => e.currentTarget.style.background = theme.bgHover}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
              >{c.icon} {c.name}</button>
            ))}
          </div>
        )}
      </div>

      <div style={{ position: 'relative' }}>
        <button
          onClick={() => { setShowTagDropdown(!showTagDropdown); setShowCollectionDropdown(false); }}
          style={{
            background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
            borderRadius: 0, color: theme.textSecondary,
            fontSize: 11, fontWeight: 500, padding: '6px 12px',
            cursor: 'pointer', fontFamily: 'inherit',
          }}
        >tag</button>
        {showTagDropdown && (
          <div style={{
            position: 'absolute', bottom: '100%', left: 0, marginBottom: 4,
            background: theme.bgElevated, border: `1px solid ${theme.borderHover}`,
            borderRadius: 0, padding: 4, minWidth: 140, zIndex: 60,
            boxShadow: theme.shadow,
          }}>
            {tags.length === 0 && (
              <div style={{ padding: '6px 10px', fontSize: 11, color: theme.textFaint }}>No tags</div>
            )}
            {tags.map(t => (
              <button
                key={t.id}
                onClick={() => { onBulkTag(t.id); setShowTagDropdown(false); }}
                style={{
                  width: '100%', padding: '6px 10px', background: 'none',
                  border: 'none', borderRadius: 0, color: theme.textSecondary,
                  fontSize: 11, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                  display: 'flex', alignItems: 'center', gap: 6,
                }}
                onMouseEnter={e => e.currentTarget.style.background = theme.bgHover}
                onMouseLeave={e => e.currentTarget.style.background = 'none'}
              >
                <span style={{ width: 6, height: 6, borderRadius: '50%', background: t.color }} />
                {t.name}
              </button>
            ))}
          </div>
        )}
      </div>

      <button
        onClick={() => onBulkActivate(true)}
        style={{
          background: theme.greenBg, border: `1px solid ${theme.greenBorder}`,
          borderRadius: 0, color: theme.green,
          fontSize: 11, fontWeight: 500, padding: '6px 12px',
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >activate</button>
      <button
        onClick={() => onBulkActivate(false)}
        style={{
          background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
          borderRadius: 0, color: theme.textSecondary,
          fontSize: 11, fontWeight: 500, padding: '6px 12px',
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >deactivate</button>
      <button
        onClick={onBulkDelete}
        style={{
          background: theme.redBg, border: `1px solid ${theme.redBorder}`,
          borderRadius: 0, color: theme.red,
          fontSize: 11, fontWeight: 500, padding: '6px 12px',
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >delete</button>

      <button
        onClick={() => fontsApi.collect([...selectedFontIds]).catch(err => console.error('ZIP export failed:', err))}
        style={{
          background: theme.bgInput, border: `1px solid ${theme.borderHover}`,
          borderRadius: 0, color: theme.textSecondary,
          fontSize: 11, fontWeight: 500, padding: '6px 12px',
          cursor: 'pointer', fontFamily: 'inherit',
        }}
      >download zip</button>

      <div style={{ flex: 1 }} />

      <button
        onClick={onClearSelection}
        style={{
          background: 'none', border: 'none',
          color: theme.textMuted, cursor: 'pointer',
          fontSize: 14, fontFamily: 'inherit',
        }}
        title="Clear selection"
      >✕</button>
    </div>
  );
}
